<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button @click="newprop" icon="new" bold :text="lang.button_New" :tooltip="lang.button_New"
            :disabled="newpropButtonStatus" />
          <action-button @click="save" icon="save" bold :text="lang.button_Save" :tooltip="lang.button_Save"
            :disabled="saveButtonStatus" />




        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="false" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="false" />

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'

  import LibraryPropertiesType from '@/constants/LibraryPropertiesType'


  import Content from "@/components/LibraryManager/Views/Properties/Middle/Content/Content"

  import { mapGetters } from 'vuex'

//import LibraryPropertiesType from '../../../../../constants/LibraryPropertiesType'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {

      newpropButtonStatus: false,
      backButtonStatus: false,
      saveButtonStatus: false,
      exportCisButtonStatus: false,
      saving: false,
      propsTable: ""
    }
  },
  computed:{
    ...mapGetters({
            selectedTreeLibraryItemObject: 'selectedTreeLibraryItemObject',

          }),
    propertyToSaving(){
      return this.$store.getters.propertyToSaving
    },
    categoryId(){
      if (this.selectedTreeLibraryItemObject.categoryId == undefined){
        return 1;
      }
      return this.selectedTreeLibraryItemObject.categoryId;
    },

  },
  created() {


  },
  methods: {
    validationTable(){

      
      this.propsTable
        .search("")
        .draw(); 
      
      let elements = document.querySelectorAll(".type-props, .browsable-props")
      
      if (elements.length == 0){
        const obj = {
          text: this.lang.alert_error_NoProperties,
          time: 15,
          type: "danger"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }
           
      let trigLibraryNumber = 0, trigLibraryType = 0, trigLibraryImage = 0;
      const ob = {};
      for (let i = 0, lei = elements.length; i < lei; i++){
        
        if (elements[i].dataset.origins === "own") {
          console.log(elements[i].dataset.origins, elements[i].value)
          if (elements[i].value == LibraryPropertiesType.LIBRARYNUMBER) {
            trigLibraryNumber++;
          }
          if (elements[i].value == LibraryPropertiesType.LIBRARYTYPE) {
            trigLibraryType++;
          }
          if (elements[i].value == LibraryPropertiesType.IMAGE) {
            trigLibraryImage++;
          }
        }
        
        
      }
      
      
      
      let isTooMuch = true;
      let what = "";
      if (trigLibraryNumber > 1){
        isTooMuch = false;
        what = LibraryPropertiesType.LIBRARYNUMBER;
      }
      if (trigLibraryType > 1){
        isTooMuch = false;
        what = LibraryPropertiesType.LIBRARYTYPE;
      }
      if (trigLibraryImage > 1){
        isTooMuch = false;
        what = LibraryPropertiesType.IMAGE;
      }
      

      if (isTooMuch == false){
        const obj = {
          text: this.lang.alert_error_DuplicateProperty + " (" + what + ")",
          time: 15,
          type: "danger"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }
      if (trigLibraryNumber == 0){
        const obj = {
          text: this.lang.alert_error_NoPartNumber,
          time: 15,
          type: "danger"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }
      if (trigLibraryType == 0){
        const obj = {
          text: this.lang.alert_error_NoLibraryType,
          time: 15,
          type: "danger"
        }

        this.$store.dispatch("displayFooterAlert", obj);

        return false;
      }


      return true;
    },
    save(){

      let _vue = this;

      let isValid = this.validationTable();

      
      if (!isValid){

        
        return

      }
     

      for (let i = 0, lei = this.propertyToSaving.length; i < lei; i++){

        this.propertyToSaving[i].categoryId = this.categoryId;


        this.$store.dispatch(this.$store.getters.sectionPrefix + "_updateProperty", this.propertyToSaving[i])
            .then(function(result) {
              
              console.log(result)

              if (result.status == "OK"){
            
                if (i + 1 == lei){

                  const obj = {
                    text: _vue.lang.alert_success_Update,
                    time: 5,
                    type: "success"
                  }

                  _vue.$store.dispatch("displayFooterAlert", obj);
                  
                  //reload table
                  const reloadObj = {
                      status: true,
                      name: "FormLibraryPropertiesComponent"
                  }
                  _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                }else{
                  
                }
   
              }else{
                

                const obj = {
                  text: _vue.lang.alert_error_Update,
                  time: 10,
                  type: "danger"
                }

                _vue.$store.dispatch("displayFooterAlert", obj);
              }

            })
      }
      const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiLibComponent"
      }
      this.$store.dispatch("reloadAfterActionComplex", reloadObj);

    },
    
   
    newprop(){
      

      let _vue = this;

      let funcYes = function(e){

        let form = _vue.$store.getters.createPropertyForm;
        let isRequiredOnRequest = form.checked.includes("isRequiredOnRequest");
        let isRequiredOnRelease = form.checked.includes("isRequiredOnRelease");
        let isRevisionChanging = form.checked.includes("isRevisionChanging");
        let hdlGlobal = form.checked.includes("hdlGlobal");
        

        let obj = {
          categoryId: _vue.$store.getters.selectedTreeLibraryItemObject.categoryId,
          name: form.name,
          type: form.type,
          isRequiredOnRequest: isRequiredOnRequest,
          isRequiredOnRelease: isRequiredOnRelease,
          isRevisionChanging: isRevisionChanging,
          hdlGlobal: hdlGlobal
        }

        _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_createProperty", obj)
        .then(function(result) {
          
          console.log(result)

          if (result.status == "OK"){

            if (result.data != null){
              const obj = {
                text: _vue.lang.alert_success_NewProperty,
                time: 10,
                type: "success"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);

              const reloadObj = {
                status: true,
                name: "FormLibraryPropertiesComponent"
              }
              _vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
            }else{
              const obj = {
                text: _vue.lang.alert_error_NewProperty + ".",
                time: 15,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);
            }

          }else{
            const obj = {
              text: _vue.lang.alert_error_NewProperty + ": " + result.message,
              time: 15,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj);
          }

          
        })

      }

      var obj = {
        
        text: "",
        type: "new_library_property",
        buttons: 2,
        size: "lg",
        lang: this.lang.modal_NewProperty,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);


    },
    back(){

      let to = this.$route.query.from;

      
      this.$store.commit("BACKROUTINGDATA");
      

      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query })
    },
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/Properties/Middle/Middle.vue